export default __webpack_public_path__ + "static/media/da3b59e34991268f1532c2382228946b.svg";